import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useStateContext } from 'provider/StateProvider'
import { Title } from 'components/Title'
import { Timeline } from 'components/Timeline'
import { ActionButton } from 'components/ActionButton'
import { KouzuiPanel } from 'components/KouzuiPanel'
import { DosyaPanel } from 'components/DosyaPanel'


export const RiskConfirm = () => {
  const state = useStateContext()
  const navigate = useNavigate()

  React.useEffect(() => {
    if (state.area === '' || state.city === '') {
      navigate('/')
    }
  }, [])

  const goNext = (): void => {
    const sinsuiRiskLevel = state.getSinsuiRiskLevel()
    // 家屋倒壊、土砂災害優先
    if (state.hasKaokutoukaiRisk() === true || state.getDosyaWarningLevel() > 0 || sinsuiRiskLevel >= 4) {
      navigate('/dest-place')
    } else if (sinsuiRiskLevel > 0) {
      navigate('/dest-flood')
    } else if (state.hasRisk() === true) {
      navigate('/dest-place')
    } else {
      navigate('/dest-confirm')
    }
  }

  return (
    <div>
      <Title text='自宅の洪水・土砂災害リスクの確認' />
      <Timeline process={1} />

      { 'あなたの自宅の洪水・土砂災害リスク' }
      <KouzuiPanel />
      <DosyaPanel />

      <ActionButton text='次へ' color='primary' mt={3} onClick={goNext} />
      <ActionButton text='戻る' color='secondary' onClick={() => navigate(-1)} />
    </div>
  )
}
